import React from 'react';
import {BuilderPot} from '../../../schema-types/BuilderPot';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {usePlanValidationLevel} from '../CreateBuilder/BuilderSourceDestination/usePlanValidationLevel';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {getSummary} from '../CreateBuilder/BuilderSourceDestination/builderNaming';
import {BuilderTransferSourceForm} from '../BuilderTransfer/BuilderTransferSourceForm';
import {getCurrencyFloat} from '../../../utils/currencyFormatter';

interface AnnuitySourceRowProps {
  pot: BuilderPot;
  index: number;
  isSelected: boolean;
  handleChange: () => void;
}

export const AnnuitySourceRow: React.FC<AnnuitySourceRowProps> = ({
  pot,
  index,
  isSelected,
  handleChange,
}) => {
  const formikKeyPrefix = isSelected ? `transfer.transferSources.${pot.id}` : undefined;
  const {bgClass} = usePlanValidationLevel(formikKeyPrefix);

  return (
    <PlanRow
      id={pot.id}
      reccId={pot.originalOvrId ?? null}
      curoId={pot.curoId}
      isSelected={isSelected}
      isSubplan={false}
    >
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent={(pot.dentistChildren?.length ?? 0) === 0}
        validationLevel={bgClass}
        summaryChildren={
          <>
            <PlanSelector
              mode="single"
              id={pot.id}
              isSelected={isSelected}
              handleChange={handleChange}
            />
            {getSummary(pot)}
          </>
        }
        summaryTrailing={
          formikKeyPrefix ? (
            <PlanValidationIcon formikKeyPrefix={formikKeyPrefix} />
          ) : undefined
        }
      >
        <BuilderTransferSourceForm
          pot={pot}
          id={pot.id}
          index={index}
          maxAmount={getCurrencyFloat(pot.totalValue)}
          hasInSpecie={false}
        />
      </PlanAccordionShell>
    </PlanRow>
  );
};
